const oneLbsInGrams = 453.592_37;
const oneKgInGrams = 1000;
const oneOunceInGrams = 28.349_523_125;
const oneTonneInGrams = 1_000_000;

export const ouncesToGrams = (ounces: number): number => {
  return ounces * oneOunceInGrams;
};

export const poundsToGrams = (pounds: number): number => {
  return pounds * oneLbsInGrams;
};

export const gramsToPounds = (grams: number): number => {
  return grams / oneLbsInGrams;
};

export const kilogramsToGrams = (kilograms: number): number => {
  return kilograms * 1000;
};

export const tonnesToGrams = (tonnes: number): number => {
  return tonnes * oneTonneInGrams;
};

export function stringToWeightUnit(weightUnit: string): WeightUnit {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  return WeightUnit[weightUnit as keyof typeof WeightUnit];
}

export function parseWeightUnit(weightUnit: string): WeightUnit | undefined {
  return weightUnitAliases[weightUnit.trim().toLowerCase()];
}

export function convertWeight(
  weight: number,
  from: WeightUnit,
  to: WeightUnit,
): number {
  if (from === to) {
    return weight;
  }

  let weightInGrams = weight;
  //First convert the weight to grams
  switch (from) {
    case WeightUnit.GRAMS:
      break;
    case WeightUnit.KILOGRAMS:
      weightInGrams *= oneKgInGrams;
      break;
    case WeightUnit.OUNCES:
      weightInGrams *= oneOunceInGrams;
      break;
    case WeightUnit.POUNDS:
      weightInGrams *= oneLbsInGrams;
      break;
    case WeightUnit.TONNES:
      weightInGrams *= oneTonneInGrams;
      break;
    default:
      break;
  }

  switch (to) {
    case WeightUnit.GRAMS:
      return weightInGrams;
    case WeightUnit.KILOGRAMS:
      return weightInGrams / oneKgInGrams;
    case WeightUnit.OUNCES:
      return weightInGrams / oneOunceInGrams;
    case WeightUnit.POUNDS:
      return weightInGrams / oneLbsInGrams;
    case WeightUnit.TONNES:
      return weightInGrams / oneTonneInGrams;
    default:
      return weightInGrams;
  }
}
export const convertShopifyWeightToGrams = (
  weight: number,
  weightUnit: string,
): number => {
  switch (weightUnit) {
    case "GRAMS":
      return weight;
    case "KILOGRAMS":
      return kilogramsToGrams(weight);
    case "OUNCES":
      return ouncesToGrams(weight);
    case "POUNDS":
      return poundsToGrams(weight);
    case "TONNES":
      return tonnesToGrams(weight);
    default:
      return weight;
  }
};

export namespace WeightUnit {
  export const GRAMS = "g";
  export const KILOGRAMS = "kg";
  export const OUNCES = "oz";
  export const POUNDS = "lb";
  export const TONNES = "t";
}

export type WeightUnit =
  | typeof WeightUnit.GRAMS
  | typeof WeightUnit.KILOGRAMS
  | typeof WeightUnit.OUNCES
  | typeof WeightUnit.POUNDS
  | typeof WeightUnit.TONNES;

const weightUnitAliases: Record<string, WeightUnit> = {
  g: WeightUnit.GRAMS,
  gram: WeightUnit.GRAMS,
  grams: WeightUnit.GRAMS,
  kg: WeightUnit.KILOGRAMS,
  kgs: WeightUnit.KILOGRAMS,
  kilo: WeightUnit.KILOGRAMS,
  kilos: WeightUnit.KILOGRAMS,
  kilogram: WeightUnit.KILOGRAMS,
  kilograms: WeightUnit.KILOGRAMS,
  oz: WeightUnit.OUNCES,
  ozs: WeightUnit.OUNCES,
  ounce: WeightUnit.OUNCES,
  ounces: WeightUnit.OUNCES,
  lb: WeightUnit.POUNDS,
  lbs: WeightUnit.POUNDS,
  pound: WeightUnit.POUNDS,
  pounds: WeightUnit.POUNDS,
  t: WeightUnit.TONNES,
  tonne: WeightUnit.TONNES,
  tonnes: WeightUnit.TONNES,
};
